var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container", staticStyle: { position: "relative" } },
      [
        _c("div", { staticClass: "circle-parent" }, [
          _c(
            "div",
            {
              staticClass: "circle",
              style: {
                borderColor: _vm.getColor(
                  `${_vm.type.toUpperCase()} Initiation`
                ),
              },
            },
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.getTitle(
                      `${_vm.type.toUpperCase()} Initiation`
                    ),
                    placement: "top-end",
                  },
                },
                [_c("p", [_vm._v("Publish")])]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "circle",
              style: { borderColor: _vm.getColor("Supplier Submit Proposal") },
            },
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.getTitle("Supplier Submit Proposal"),
                    placement: "top-end",
                  },
                },
                [
                  _c("div", [
                    _c("p", [_vm._v("Proposal")]),
                    _c("p", [
                      _vm._v("（" + _vm._s(_vm.romanRoundNumber) + "）"),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "circle",
              style: { borderColor: _vm.getColor("Recommendation") },
            },
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.getTitle("Recommendation"),
                    placement: "top-end",
                  },
                },
                [
                  _c("div", [
                    _c("p", [_vm._v("Recommen")]),
                    _c("p", [_vm._v("dation")]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm.type == "ssr"
            ? _c(
                "div",
                {
                  staticClass: "circle",
                  style: { borderColor: _vm.getColor("Business Case") },
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: _vm.getTitle("Business Case"),
                        placement: "top-end",
                      },
                    },
                    [_c("p", [_vm._v("BC")])]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "legend" }, [
          _c("ul", [
            _c("li", { staticStyle: { color: "#909399" } }, [
              _c("i", { staticClass: "icon icon-yuan" }),
              _vm._v(_vm._s(_vm.$t("ssrManage.greMsg"))),
            ]),
            _c("li", { staticStyle: { color: "#67C23A" } }, [
              _c("i", { staticClass: "icon icon-yuan" }),
              _vm._v(_vm._s(_vm.$t("ssrManage.greenMsg"))),
            ]),
            _c("li", { staticStyle: { color: "#E6A23C" } }, [
              _c("i", { staticClass: "icon icon-yuan" }),
              _vm._v(_vm._s(_vm.$t("ssrManage.yellowMsg"))),
            ]),
            _c("li", { staticStyle: { color: "#FB4E4E" } }, [
              _c("i", { staticClass: "icon icon-yuan" }),
              _vm._v(_vm._s(_vm.$t("ssrManage.redMsg"))),
            ]),
          ]),
        ]),
        _c(
          "el-tabs",
          { attrs: { type: "border-card" } },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: `${_vm.type.toUpperCase()} Information` } },
              [
                _c(
                  "div",
                  { staticStyle: { "padding-bottom": "15px" } },
                  [
                    _vm.ssr.owned && _vm.ssr.status != "SUSPEND"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.showDialog = true
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("ssrManage.breakUp")))]
                        )
                      : _vm._e(),
                    _vm.canFinishRound
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.roundsEnd },
                          },
                          [_vm._v(_vm._s(_vm.$t("ssrManage.roundsEnd")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("ssr-manage-add", {
                  model: {
                    value: _vm.ssr,
                    callback: function ($$v) {
                      _vm.ssr = $$v
                    },
                    expression: "ssr",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "Proposal" } },
              [
                _c("supplier-pane", {
                  attrs: { rounds: _vm.ssr.ssrRounds, ssr: _vm.ssr },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "PQCP" } },
              [_c("offer-info-pane", { attrs: { rounds: _vm.ssr.ssrRounds } })],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "Cost Breakdown" } },
              [_c("cose-info-pane", { attrs: { rounds: _vm.ssr.ssrRounds } })],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "Capacity Analysis" } },
              [
                _c("production-info-pane", {
                  attrs: { rounds: _vm.ssr.ssrRounds },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "Logistics Capacity" } },
              [_c("logistics-pane", { attrs: { rounds: _vm.ssr.ssrRounds } })],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "SPM" } },
              [
                _c("spm-core-pane", {
                  attrs: { rounds: _vm.ssr.ssrRounds, ssr: _vm.ssr },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "Log" } },
              [
                _c("workflow-log-table", {
                  attrs: { logs: _vm.ssr.workflowLogs },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "是否需要终止流程？",
              visible: _vm.showDialog,
              width: "500px",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showDialog = $event
              },
            },
          },
          [
            _c(
              "el-form",
              { attrs: { "label-width": "100px" } },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "space-around" } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "填写备注",
                              placeholder: "",
                              prop: "remark",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.remark,
                                callback: function ($$v) {
                                  _vm.remark = $$v
                                },
                                expression: "remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer", align: "center" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.breakUp } },
                  [_vm._v("Submit")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.showDialog = false
                      },
                    },
                  },
                  [_vm._v(_vm._s("Close"))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }